exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".arrow_icon[data-v-486b977a]{position:absolute;top:-1.666667rem;right:9.5%;width:0;height:0;border:1.666667rem solid;border-color:transparent transparent #a99e9e}.arrow_icon2[data-v-486b977a]{position:absolute;top:-1.5rem;z-index:1000;right:9.5%;width:0;height:0;border:1.666667rem solid;border-color:transparent transparent #eceaea}.operatorLog-details-cla[data-v-486b977a]{padding:1.25rem}.operatorLog-details-cla .item-detail-cla[data-v-486b977a]{padding:.833333rem 0;border-bottom:.083333rem solid #dedcda}.name-wrapper[data-v-486b977a]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-486b977a","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/cdpBase/baseComponents/operatorLog/src/main.vue
// module id = Llft
// module chunks = 19